/**
 * What Archi is doing while it answers, in words: each read it makes becomes
 * one step ("Reading cloud connections…" → "Read cloud connections"). Archi
 * sends the label with the step; a step without one shows its name made
 * readable.
 */
export function toolLabel(name: string, label?: string): string {
  if (label) return label;
  return name.replace(/^(get|list)_/, "").replace(/_/g, " ");
}

export type ToolStepStatus = "running" | "done" | "error";

export interface ToolStep {
  id: string;
  name: string;
  label?: string;
  status: ToolStepStatus;
}
